var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard4E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame_730px_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "beard_x5F_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x33__1_",
    d: "M450.3,326.9c1.6-9.5,2.7-18,3.8-27.7c0.2-2.3,0.4-4.7,0.5-7s0.1-4.7,0-7.1c0.2-7,0.2-14,0-21.1 c-2.5,18.2-4.4,36.3-9.9,53.9c-2.7,8.6-12,16-17.8,22.7c-6,7.1-11.4,22-18.8,27c1.1-8.5,0.6-19.7-0.4-26c-0.8-5.3-8.8-7.7-13.2-9.4 c-3.4-1.3-6.1-2-9.7-2.9c-1.9-0.4-5.5,3-7.4,4.1c-5.4,3.2-10.8,4.5-17,5.1c-7.7,0.1-12.6-1.4-18.1-4.5c-1.6-0.9-4.6-3.7-6.8-5.5 c-0.4-0.3-2.3,0.2-2.7,0.3c-3.5,1-6.2,1.7-9.7,3c-4.4,1.6-12.4,4.7-15.6,8.9c-3.6,4.8-2.3,19.5-2.1,25.9c-6-8.5-8.9-19.1-13.9-27 S275,322,272.3,313.3c-5.6-17.7-10-31.8-12.5-50.2c-1.3,15.7,0.7,33.4,3.9,49.2c0.6,3.2,1.4,6.3,2.2,9.4c10.2,36.1,33.6,68,62,92.2 c4,2.9,5.9,3.6,11,3.5c5.2-0.1,7.2-0.2,12.4,0c2.2,0.1,8.1-0.1,10.3-0.1c2.2,0,4.4,0,6.6-0.1c5.2-0.2,7.1-0.3,12.2-0.2 c5.1,0.1,9.2-2.1,13.1-4.9c21-20.2,40.1-42.6,52.4-69.3c1.1-3,2-6.1,2.8-9.3C449.3,331.4,449.8,329.2,450.3,326.9z M401.5,360.6 c-0.5,4.9-0.6,9.8-3.6,13.9c-2.5,3.7-6.8,6.2-10.5,8.6c-3.3,2.2-9,6.1-12.1,2.2c-2.1-2.7-4.4-9.1-8.1-9.4c-2.6-0.2-5.3,0.1-7.9,0.2 l0,0c-2.1,0.1-4.1,0.4-6.3,0.5c-3.7,0.3-5,6.8-8.7,9.3c-4.1,2.9-12.1,0.2-15.9-1.3c-4.4-1.9-9.7-4.1-12.3-7.7 c-2.9-4.2-2.7-11.2-2.4-16.2c0.2-4.4,0.4-6.5,0.9-10.9c0.6-5.1,4.7-5.2,13.6-5.7c10.4-0.6,21.5-1.8,31.9-2 c10.2,0.1,20.3-0.2,30.5,0.1c4.2,0.1,9.2-0.4,9.9,4.8C401.2,351.3,401.9,356.1,401.5,360.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard4E);
export default __webpack_public_path__ + "static/media/man_beard_4e.a57ea1932f44b0c2c269f5300151c416.svg";
export { ForwardRef as ReactComponent };